export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"
export const CLEAR_FORGET_PASSWORD = "CLEAR_FORGET_PASSWORD"

export const RESET_FORGET_PASSWORD = "RESET_FORGET_PASSWORD"
export const RESET_FORGET_PASSWORD_SUCCESS = "RESET_FORGET_PASSWORD_SUCCESS"
export const RESET_FORGET_PASSWORD_ERROR = "RESET_FORGET_PASSWORD_ERROR"
